import masrafLogo from '../asset/img/masraf_icon.png'
import portLogo from '../asset/img/port_icon.png'
import puantajLogo from '../asset/img/puantaj_icon.png'


export const getUrlParams = () => window.location.search
  .substring(1).split('&')
  .reduce((acc, notParsedValue) => {
    const [key, value] = notParsedValue.split('=');

    return key ? { ...acc, [key]: value } : { ...acc };
  }, {});




// WEBPACK FOOTER //
// ./src/constants/utils.js